var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconBasket = function SvgIconBasket(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B5C4",
    fillRule: "evenodd",
    d: "M12.273 3c.009 0 .026.008.034.017.008-.009.025-.017.05-.017.263 0 .474.203.474.465v1.301h2.003a1.01 1.01 0 0 1 1.022 1.023v.794a.879.879 0 0 1-.879.879v9.524c0 .575-.447 1.014-1.022 1.014H5.9a.996.996 0 0 1-1.014-1.014V7.462l-.111-.007A.888.888 0 0 1 4 6.575v-.786a1.01 1.01 0 0 1 1.023-1.023h2.01V3.465c0-.262.204-.465.466-.465zm1.766 4.462H5.817v9.524c0 .06.025.084.084.084h8.054c.06 0 .084-.025.084-.084V7.462zM12.1 8.552c.26 0 .47.21.47.47v6.751a.469.469 0 0 1-.939 0V9.021c0-.259.21-.469.47-.469zm-2.163 0c.259 0 .469.21.469.47v6.751a.469.469 0 1 1-.938 0V9.021c0-.259.21-.469.469-.469zm-2.164 0c.26 0 .47.21.47.47v6.751a.469.469 0 0 1-.939 0V9.021c0-.259.21-.469.47-.469zm7.06-2.856h-9.81c-.06 0-.085.034-.085.093v.743h9.98V5.79c0-.06-.025-.093-.084-.093zm-2.94-1.766h-3.93v.836h3.93V3.93z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBasket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-basket.c6b4d3ba.svg";
export { ForwardRef as ReactComponent };